import axios from 'axios'
import i18n from '@/i18n'

export const SourceManual = 'Manual'
export const SourceGoogle = 'Google'
export const SourceBing = 'Bing'
export const SourceGoogleStock = 'Google stock'

export async function confirmChecker(outAddress, search) {
  const [fInput, fSearch] = await axios.post(
    '/ajax/PullAddress.php',
    { address: [outAddress.address, search.split(',')[0]] },
    { params: { action: 'formattingAddress' } },
  ).then(({ data: { address } }) => address)

  if (fInput.toLowerCase() !== fSearch.toLowerCase()) {
    // dd
    const t = (key, params) => i18n.global.t(key, params)
    const entered = search.split(',')[0]
    return window.getConfirm(`<h4>${t('common.address-check.title')}</h4><div>${t('common.address-check.entered')} <b>${entered}</b><br> ${t('common.address-check.validated')} <b>${outAddress.address}</b></div>`, {
      buttons: {
        apply: { label: t('common.address-check.accept'), color: 'success' },
        manual: { label: t('common.address-check.keep'), color: 'red', class: 'ml-2' },
        cancel: { label: t('common.address-check.cancel'), color: 'grey lighten-1', class: 'ml-2' },
      },
    })
  }
  return Promise.resolve(true)
}

export function resetAddress(input) {
  input.address = ''
  input.zip = ''
  input.street_number = ''
  input.street = ''
  input.lat = ''
  input.lng = ''
  input.state = ''
  input.city = ''
  input.place_id = ''
  input.formatted_address = ''
  input.adjusted = false
}

export function nGps(v) {
  const tmp = parseFloat(v, 10)
  return ((((tmp % 360) + 540) % 360) - 180).toFixed(6)
}
